import { Capacitor } from "@capacitor/core";
import { getScreenInfo } from "shared/helpers/device-info/getScreenInfo";
import {
  type DeviceInfo as SharedDeviceInfo,
  Platform as SharedPlatform,
} from "shared/types/DeviceInfo";
import { getParentViewport } from "hub/src/utils/iframe/parentViewport";
import { isIframeSSOPage } from "hub/src/utils/isIframeSSOPage";

/**
 * @deprecated Import `Platform` from `shared/types/DeviceInfo` instead.
 */
export const Platform = SharedPlatform;
/**
 * @deprecated Import `Platform` from `shared/types/DeviceInfo` instead.
 */
export type Platform = SharedPlatform;

/**
 * @deprecated Import `DeviceInfo` from `shared/types/DeviceInfo` instead.
 */
export type DeviceInfo = SharedDeviceInfo;

/**
 * The viewport in CSS pixels - `innerWidth`/`innerHeight` are the numbers media
 * queries compare against, so a Max Width of 500 here means what
 * `@media (max-width: 500px)` means. Inside the SSO iframe the height and
 * orientation come from the parent window instead (see `getScreenInfo`).
 */
const readScreenInfo = (): Pick<
  SharedDeviceInfo,
  "orientation" | "width" | "height"
> => {
  if (typeof window === "undefined") {
    return {};
  }
  return getScreenInfo({
    window: { width: window.innerWidth, height: window.innerHeight },
    embedded: Boolean(isIframeSSOPage),
    parentViewport: getParentViewport(),
  });
};

export const getDeviceInfo = (): SharedDeviceInfo => {
  const platform = Capacitor.getPlatform() as SharedPlatform;
  const isNativeApp = Capacitor.isNativePlatform();

  return {
    platform,
    isNativeApp: isNativeApp,
    isAndroid: platform === SharedPlatform.Android,
    isIOS: platform === SharedPlatform.iOS,
    isWeb: platform === SharedPlatform.Web,
    ...readScreenInfo(),
  };
};
